import type { MutableRefObject } from "react";
import { LangObject, Status, Team } from "@brg/api";
import { CHAT_CLOSED_STATUS } from "../const/ModerationTypes";
import { ITeamTab } from "../components/TeamTabEdit";
import { TabType } from "../components/TeamTabsBlock";

export enum TeamAdminEditType {
    NORMAL = 'normal',
    CHANNEL = 'channel',
    SIMPLY = 'simply',
    LIMITED = 'limited'
}

export interface  ITeamSections {
    editType: TeamAdminEditType | undefined,
    canEditServiceTeam?: boolean,
    sip: any,
    isProjectLoading?: boolean,
    projectError?: boolean,
    canSaveLgText?: boolean,
    modalSettings?: any,
    onDeleteBG: () => void,
    onToggleLgView: () => void,
    onSaveChange: (val: boolean) => void,
    onStatusTextChange: (val: any) => void,
    onModalStateChange: (flag: boolean, settings: any) => void,
    onGroupDelete?: (id: string) => void,
    onChannelQuit?: () => void,
    primaryButtonClick?: () => void,
    setIsTeamDeleted?: (val: boolean) => void,
    showLoader?: boolean,
    isExternalCreateRoute?: boolean
    lmsModulesRefreshKey?: number
}

export interface ITeamWithProps extends Team {
    isServiceTeam?: boolean;
    isPublicShowcase?: boolean;
    moderationType?: any,
    feedSettings?: {
        channelCommentBlackListIds?: string[],
        channelCommentWhiteListIds?: string[],
        channelCommentClosedStatus?: CHAT_CLOSED_STATUS,
        channelCommentMsg?: LangObject[],
    },
    channelCommentBlackListIds?: string[],
    channelCommentWhiteListIds?: string[],
    channelCommentClosedStatus?: CHAT_CLOSED_STATUS,
    channelCommentMsg: LangObject[],
    currentTab?: string,
    groupsSortMode?: 'added' | 'alphabet',
    groupsAddedOrderById?: Record<string, number>,
}

export interface IModalRouterProps {
    onModalStateChange: (flag: boolean, settings: any) => void,
    primaryButtonClick: () => void,
    updateTeam: () => void,
    onUpdate: (val: any) => void,
    refreshTeamData: () => void,
    refreshManagerContent: () => void,
    refreshGroups: () => void,
    onGroupDelete: (id: string) => void,
    onTeamTabChange: (mode: TabType, tab: ITeamTab, index: number) => void,
    setHasUnsavedChanges: (val: boolean) => void,
    disciplineModuleSaveRef?: MutableRefObject<(() => Promise<void>) | null>,
    onGetLongreadCount?: () => number,
    onSetLongreadCount: (val: number) => void,
    onSetAnchors: (val: any) => void,
    ModerationTypeListLocalized: any,
    hasCover?: boolean,
    team?: Team<'Local'>,
    id?: string,
    editType: TeamAdminEditType | undefined,
    isModer?: boolean | null,
    hasAccessToTeamsAdmin?: boolean,
    actualForms?: any[],
    anchorTypes?: any[],
    maxLGButtonsCount?: number,
}

export interface IStatusesData extends Status {
    users: any[]
}

import type { MutableRefObject } from "react";
import { LangObject, Status, Team } from "@brg/api";
import { CHAT_CLOSED_STATUS } from "../const/ModerationTypes";
import { ITeamTab } from "../components/TeamTabEdit";
import { TabType } from "../components/TeamTabsBlock";

export enum TeamAdminEditType {
    NORMAL = 'normal',
    CHANNEL = 'channel',
    SIMPLY = 'simply',
    LIMITED = 'limited'
}

export interface  ITeamSections {
    editType: TeamAdminEditType | undefined,
    canEditServiceTeam?: boolean,
    sip: any,
    isProjectLoading?: boolean,
    projectError?: boolean,
    canSaveLgText?: boolean,
    modalSettings?: any,
    onDeleteBG: () => void,
    onToggleLgView: () => void,
    onSaveChange: (val: boolean) => void,
    onStatusTextChange: (val: any) => void,
    onModalStateChange: (flag: boolean, settings: any) => void,
    onGroupDelete?: (id: string) => void,
    onChannelQuit?: () => void,
    primaryButtonClick?: () => void,
    setIsTeamDeleted?: (val: boolean) => void,
    showLoader?: boolean,
    isExternalCreateRoute?: boolean
    lmsModulesRefreshKey?: number
}

export interface ITeamWithProps extends Team {
    isServiceTeam?: boolean;
    isPublicShowcase?: boolean;
    moderationType?: any,
    feedSettings?: {
        channelCommentBlackListIds?: string[],
        channelCommentWhiteListIds?: string[],
        channelCommentClosedStatus?: CHAT_CLOSED_STATUS,
        channelCommentMsg?: LangObject[],
    },
    channelCommentBlackListIds?: string[],
    channelCommentWhiteListIds?: string[],
    channelCommentClosedStatus?: CHAT_CLOSED_STATUS,
    channelCommentMsg: LangObject[],
    currentTab?: string,
    groupsSortMode?: 'added' | 'alphabet',
    groupsAddedOrderById?: Record<string, number>,
}

export interface IModalRouterProps {
    onModalStateChange: (flag: boolean, settings: any) => void,
    primaryButtonClick: () => void,
    updateTeam: () => void,
    onUpdate: (val: any) => void,
    refreshTeamData: () => void,
    refreshManagerContent: () => void,
    refreshGroups: () => void,
    onGroupDelete: (id: string) => void,
    onTeamTabChange: (mode: TabType, tab: ITeamTab, index: number) => void,
    setHasUnsavedChanges: (val: boolean) => void,
    disciplineModuleSaveRef?: MutableRefObject<(() => Promise<void>) | null>,
    onGetLongreadCount?: () => number,
    onSetLongreadCount: (val: number) => void,
    onSetAnchors: (val: any) => void,
    ModerationTypeListLocalized: any,
    hasCover?: boolean,
    team?: Team<'Local'>,
    id?: string,
    editType: TeamAdminEditType | undefined,
    isModer?: boolean | null,
    hasAccessToTeamsAdmin?: boolean,
    actualForms?: any[],
    anchorTypes?: any[],
    maxLGButtonsCount?: number,
}

export interface IStatusesData extends Status {
    users: any[]
}

